import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useUsers } from "../../../context/UserContext";
import AddUserScreen from "./userScreens/AddUserScreen";
import UsersListScreen from "./userScreens/UsersListScreen";

const Users: React.FC = () => {
  const { users } = useUsers();

  // Conditional redirect based on users count
  const ConditionalRedirect = () => {
    if (users.length > 0) {
      return <Navigate to="/users/list" replace />;
    } else {
      return <Navigate to="/users/add" replace />;
    }
  };

  return (
    <Routes>
      {/* Default route redirects conditionally */}
      <Route path="/" element={<ConditionalRedirect />} />

      {/* Add User Screen */}
      <Route path="/add" element={<AddUserScreen />} />

      {/* List Users Screen */}
      <Route path="/list" element={<UsersListScreen />} />

      {/* Fallback */}
      <Route path="*" element={<ConditionalRedirect />} />
    </Routes>
  );
};

export default Users;